module.exports = __webpack_public_path__ + "static/media/postgres.de71b010.png";